import React, { useMemo, useState } from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import { NeutralThemeProvider, useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import WaitingBalloonGame from '@/components/Messages/WaitingBalloonGame';
import WaitingFlappyGame from '@/components/Messages/WaitingFlappyGame';
import WaitingSnakeGame from '@/components/Messages/WaitingSnakeGame';

const GAMES = [
  { id: 'balloon', name: 'Balloon Pop', component: WaitingBalloonGame },
  { id: 'flappy', name: 'Flappy Flight', component: WaitingFlappyGame },
  { id: 'snake', name: 'Snake', component: WaitingSnakeGame },
];

const createStyles = colors => StyleSheet.create({
  card: { width: '100%', borderRadius: 14, borderWidth: 1, borderColor: colors.border_color_secondary, backgroundColor: colors.solid_color_primary, padding: 8, gap: 8, flexShrink: 0 },
  title: { flex: 1 },
  opener: { minHeight: 36, paddingHorizontal: 4, flexDirection: 'row', alignItems: 'center', gap: 8 },
  choices: { gap: 8 },
  choice: { minHeight: 36, borderRadius: 10, borderWidth: 1, borderColor: colors.border_color_primary, paddingHorizontal: 12, alignItems: 'center', justifyContent: 'center' },
  game: { alignItems: 'center' },
});

function WaitingGamesContent({ onExpand }) {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);
  const [expanded, setExpanded] = useState(false);
  const [selected, setSelected] = useState(null);

  const Game = GAMES.find(game => game.id === selected)?.component;
  const toggle = () => {
    if (expanded) { setSelected(null); setExpanded(false); }
    else { setExpanded(true); onExpand?.(); }
  };

  return <View style={styles.card} testID="work-waiting-games">
    <Pressable accessibilityRole="button" accessibilityLabel={expanded ? 'Close Work games' : 'Open Work games'} accessibilityState={{ expanded }} {...(Platform.OS === 'web' ? { 'aria-expanded': expanded } : {})} onPress={toggle} style={styles.opener}>
      <Icon name="gamepad" size={16} color={colors.text_color_secondary} />
      <Text size="xs" color="secondary" style={styles.title}>{expanded ? 'Games' : 'Play a game'}</Text>
      <Icon name={expanded ? 'chevron-up' : 'chevron-down'} size={10} color={colors.text_color_secondary} />
    </Pressable>
    {expanded && (
      <View style={styles.choices}>
        {Game ? <View style={styles.game}>
          <Game key={selected} colors={colors} compact fieldWidth={196} onHide={() => setSelected(null)} />
        </View> : GAMES.map(game => <Pressable key={game.id} accessibilityRole="button" accessibilityLabel={`Choose ${game.name}`} onPress={() => { setSelected(game.id); onExpand?.(); }} style={({ pressed }) => [styles.choice, { opacity: pressed ? 0.7 : 1 }]}>
          <Text size="s" weight="medium">{game.name}</Text>
        </Pressable>)}
      </View>
    )}
  </View>;
}

export default function WorkWaitingGames(props) {
  return <NeutralThemeProvider><WaitingGamesContent {...props} /></NeutralThemeProvider>;
}
